import React from "react";

import { FormTasksView } from "components/FormTasksView";

const AwardTasksView = () => {
	return (
		<FormTasksView />
	);
};

export default AwardTasksView;
